const LINE_WIDTHS = ["w-[88%]", "w-[88%]", "w-[60%]", "w-[88%]", "w-[60%]"];

interface DecorativeTestSheetProps {
    name: string;
    className?: string;
}

/** Decorative mini "page" of a test: its name as headline plus faux text lines. Parents position it. */
const DecorativeTestSheet = (props: DecorativeTestSheetProps) => {
    return (
        <span
            className={`flex flex-col gap-[6px] w-[92px] h-[118px] p-[10px] bg-white border border-p6-grey-lightest rounded-xsmall-container text-left shadow-[0_6px_18px_rgba(0,0,0,0.12)] ${
                props.className ?? ""
            }`}
        >
            <span className="text-[8px] font-bold leading-tight text-p6-grey-dark line-clamp-2">{props.name}</span>
            {LINE_WIDTHS.map((width, index) => (
                <span
                    key={index}
                    className={`block h-[3px] rounded-[2px] bg-p6-grey-light ${width}`}
                />
            ))}
        </span>
    );
};

export default DecorativeTestSheet;
